import inpageActionTypes from 'InpageEditorUI/redux/actions/actionTypes';
import { SYNC_INAPP_STATE, LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN, LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW, LAYOUT_SECTION_COLUMN_INSERTED_AFTER, LAYOUT_SECTION_COLUMN_INSERTED_BEFORE, LAYOUT_SECTION_ROW_INSERTED_AFTER, LAYOUT_SECTION_ROW_INSERTED_BEFORE, LAYOUT_SECTION_ROW_APPENDED, LAYOUT_SECTION_COLUMNS_RESIZED, LAYOUT_SECTION_ROW_PREPENDED, LAYOUT_SECTION_ROW_CLONED_BELOW, LAYOUT_SECTION_CELL_CLONED_TO_RIGHT, LAYOUT_SECTION_MODULE_DELETED, LAYOUT_SECTION_ROW_DELETED, LAYOUT_SECTION_COLUMN_DELETED, SET_IS_INLINE_FIELD_FOCUSED } from 'ContentEditorUI/redux/actions/actionTypes';
import { LAYOUT_SECTION_ADD_TEMPORARY_OVERLAY, LAYOUT_SECTION_REMOVE_TEMPORARY_OVERLAY } from 'ContentEditorUI/redux/actions/inpageReduxActionTypes';
import { calculateDropTargetFromHoverPositions } from 'InpageEditorUI/lib/layoutSection/dropTargetCalculator';
import { calculateDragHandlesFromHoverPositions } from 'InpageEditorUI/lib/layoutSection/dragHandlesCalculator';
import { calculateColumnResizeHandlesFromHoverPositions } from 'InpageEditorUI/lib/layoutSection/resizeHandleCalculator';
import { isResizeHandleType } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
import produce from 'immer';
import set from 'hs-lodash/set';
import equals from 'hs-lodash/isEqual';
const defaultBodyOffset = {
  left: 0,
  top: 0
};
export const initialStateAsJSObject = {
  currentColumnResizeHandles: null,
  currentDragItem: null,
  currentDropTarget: null,
  hoveredPositionsDeepestFirst: [],
  isDraggingOverSelf: false,
  mouseCoordsAtDrop: {},
  mouseIsInIFrame: true,
  nodePositions: {},
  nodePositionsNeedUpdate: false,
  hoverPositionsFrozen: false,
  nodePositionsBeforeTreeChange: {},
  bodyOffset: defaultBodyOffset,
  scrollPosition: {
    left: 0,
    top: 0
  },
  targetedLayoutSectionId: null,
  currentDragHandles: [],
  measuredToolbarDimensions: {},
  temporaryOverlays: [],
  renderStaticSectionResponse: null,
  // { htmlString, name, fixed_layout_section_id }
  isInlineEditableFieldFocused: false
};
const clearHandleAndHoverStackStateIfAnyMatch = ({
  draft,
  id
}) => {
  const hoveredPositionsDeepestFirst = draft.hoveredPositionsDeepestFirst;
  if (hoveredPositionsDeepestFirst.length > 0) {
    const anyHoveredIdsMatch = hoveredPositionsDeepestFirst.some(hoverPosition => hoverPosition.id === id);
    if (anyHoveredIdsMatch) {
      Object.assign(draft, {
        currentDragHandles: [],
        hoveredDragHandleType: null,
        idForHoveredDragHandle: null,
        currentColumnResizeHandles: null,
        hoveredPositionsDeepestFirst: []
      });
    }
  }
};
export const layoutSectionDndReducer = (rootState = {
  layoutSectionDnd: initialStateAsJSObject
}, action) => {
  return produce(rootState.layoutSectionDnd, draft => {
    const {
      type,
      payload
    } = action;
    switch (type) {
      case inpageActionTypes.LAYOUT_SECTION_DRAGGING_STARTED:
        {
          const {
            dragItem
          } = payload;
          if (!isResizeHandleType(dragItem.type)) {
            draft.currentColumnResizeHandles = null;
          }
          return Object.assign(draft, {
            currentDragItem: dragItem,
            currentDropTarget: null,
            // Try to prevent intermittent drop target on col resize drag
            mouseCoordsAtDrop: {}
          });
        }
      case inpageActionTypes.LAYOUT_SECTION_DRAG_ITEM_IS_HIDDEN_UPDATED:
        {
          const {
            dragItemIsHidden
          } = payload;
          if (draft.currentDragItem) {
            return set(draft, ['currentDragItem', 'hidden'], dragItemIsHidden);
          }
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_MOUSE_ENTERED_IFRAME:
        {
          draft.mouseIsInIFrame = true;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_MOUSE_LEFT_IFRAME:
        {
          draft.mouseIsInIFrame = false;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_DROP_COORDS_UPDATED:
        {
          const {
            mouseCoordsAtDrop
          } = payload;
          draft.mouseCoordsAtDrop = mouseCoordsAtDrop;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_DRAGGING_STOPPED:
        return Object.assign(draft, {
          currentColumnResizeHandles: null,
          currentDragItem: null,
          currentDropTarget: null,
          hoveredPositionsDeepestFirst: [],
          // Also ensure we thaw any frozen hover positions (we freeze hover positions on mouse down
          // of the resize handle to ensure the resize handle doesn't disappear before the drag can start)
          //
          // TODO, do we need to do the same "freeze grid on mousedown" on any other drag handles (overlays or toolbars???)
          hoverPositionsFrozen: false
        });
      case inpageActionTypes.LAYOUT_SECTION_HOVER_POSITIONS_CLEARED:
        if (!draft.hoverPositionsFrozen) {
          // Force-clear hover handles
          Object.assign(draft, {
            currentDragHandles: null,
            hoveredDragHandleType: null,
            idForHoveredDragHandle: null
          });
        }
        Object.assign(draft, {
          currentColumnResizeHandles: null,
          currentDropTarget: null,
          hoveredPositionsDeepestFirst: []
        });
        if (payload && payload.alsoFreeze) {
          draft.hoverPositionsFrozen = true;
        }
        return draft;
      case inpageActionTypes.LAYOUT_SECTION_HOVER_POSITIONS_UPDATED:
        {
          const {
            hoverPositions
          } = payload;
          const hoveredPositionsDeepestFirst = hoverPositions.filter(hoverPosition => !!hoverPosition.id);

          // Look for a D&D area at the "top" of the hover-stack
          let targetedLayoutSectionId;
          const deepestHoverPosition = hoveredPositionsDeepestFirst.at(-1);
          if (deepestHoverPosition && deepestHoverPosition.layoutSectionId && deepestHoverPosition.depth === 0) {
            targetedLayoutSectionId = deepestHoverPosition.id;
          }
          const dragItem = draft.currentDragItem;
          if (dragItem) {
            const oldDropTarget = draft.currentDropTarget;
            const {
              isDraggingOverSelf,
              newDropTarget
            } = calculateDropTargetFromHoverPositions(hoverPositions, dragItem);
            Object.assign(draft, {
              isDraggingOverSelf,
              // Stop showing hover handles when dragging starts
              currentDragHandles: [],
              hoveredDragHandleType: null,
              idForHoveredDragHandle: null,
              currentColumnResizeHandles: null
            });
            if (!newDropTarget) {
              draft.currentDropTarget = null;
            } else if (!oldDropTarget || !equals(newDropTarget, oldDropTarget)) {
              draft.currentDropTarget = newDropTarget;
            }
          } else {
            // Figure out if we have any new drag handles
            const oldDragHandles = draft.currentDragHandles;
            const newDragHandles = calculateDragHandlesFromHoverPositions(hoverPositions);
            if (!newDragHandles) {
              draft.currentDragHandles = [];
            } else if (!oldDragHandles || !equals(newDragHandles, oldDragHandles)) {
              draft.currentDragHandles = newDragHandles;
            }

            // Figure out if we have any new column resize handles
            const oldColumnResizeHandles = draft.currentColumnResizeHandles;
            const newColumnResizeHandles = calculateColumnResizeHandlesFromHoverPositions(hoverPositions);
            if (!newColumnResizeHandles) {
              draft.currentColumnResizeHandles = null;
            } else if (!oldColumnResizeHandles || !equals(newColumnResizeHandles, oldColumnResizeHandles)) {
              draft.currentColumnResizeHandles = newColumnResizeHandles;
            }
          }
          Object.assign(draft, {
            hoveredPositionsDeepestFirst,
            targetedLayoutSectionId
          });
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_NODE_POSITIONS_UPDATED:
        {
          const {
            nodePositions,
            bodyOffset
          } = payload;

          // Make sure to also initialize nodePositionsBeforeTreeChange the _first_ time node
          // positions are calculated
          if (Object.keys(draft.nodePositionsBeforeTreeChange).length === 0) {
            draft.nodePositionsBeforeTreeChange = nodePositions;
          }
          draft.bodyOffset = bodyOffset;
          draft.nodePositions = nodePositions;
          draft.nodePositionsNeedUpdate = false;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_NODE_POSITIONS_REFRESHED_BUT_UNCHANGED:
        {
          draft.nodePositionsNeedUpdate = false;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_NODE_POSITIONS_CLEARED:
        {
          draft.nodePositionsNeedUpdate = true;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_HOVER_POSITIONS_FROZEN:
        {
          draft.hoverPositionsFrozen = true;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_HOVER_POSITIONS_THAWED:
        {
          draft.hoverPositionsFrozen = false;
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_HOVERED_DRAG_HANDLE_UPDATED:
        {
          const {
            handleType,
            handleId
          } = payload;
          Object.assign(draft, {
            hoveredDragHandleType: handleType,
            idForHoveredDragHandle: handleId
          });
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_DRAG_HANDLES_BLURRED:
        {
          Object.assign(draft, {
            hoveredDragHandleType: null,
            idForHoveredDragHandle: null
          });
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_SCROLL_POSITION_CHANGED:
        {
          const {
            left,
            top
          } = payload;
          Object.assign(draft.scrollPosition, {
            left,
            top
          });
          return draft;
        }
      case inpageActionTypes.LAYOUT_SECTION_TOOLBAR_MEASURED:
        {
          // @ts-expect-error using window type
          if (window.SELENIUM_IS_RUNNING) {
            console.warn('==================\nLAYOUT_SECTION_TOOLBAR_MEASURED');
            console.warn(JSON.stringify(payload, null, 4));
          }
          const {
            name,
            size,
            width,
            height
          } = payload;
          return set(draft, ['measuredToolbarDimensions', name, size], {
            width,
            height
          });
        }
      case LAYOUT_SECTION_MODULE_DELETED:
        {
          const {
            moduleId
          } = payload;
          clearHandleAndHoverStackStateIfAnyMatch({
            draft,
            id: moduleId
          });
          return draft;
        }
      case LAYOUT_SECTION_COLUMN_DELETED:
        {
          const {
            columnId
          } = payload;
          clearHandleAndHoverStackStateIfAnyMatch({
            draft,
            id: columnId
          });
          return draft;
        }
      case LAYOUT_SECTION_ROW_DELETED:
        {
          const {
            rowId
          } = payload;
          clearHandleAndHoverStackStateIfAnyMatch({
            draft,
            id: rowId
          });
          return draft;
        }
      case LAYOUT_SECTION_ADD_TEMPORARY_OVERLAY:
        {
          const {
            rowId
          } = payload;
          draft.temporaryOverlays.push({
            rowId
          });
          return draft;
        }
      case LAYOUT_SECTION_REMOVE_TEMPORARY_OVERLAY:
        {
          const {
            rowId
          } = payload;
          const currentTemporaryOverlays = draft.temporaryOverlays;
          const newOverlays = currentTemporaryOverlays.filter(overlay => overlay.rowId !== rowId);
          draft.temporaryOverlays = newOverlays;
          return draft;
        }

      // On any tree modification, save the previous node positions
      case SYNC_INAPP_STATE:
        {
          const {
            originalActionToPassThrough
          } = action;
          if (originalActionToPassThrough && [LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN, LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW, LAYOUT_SECTION_COLUMN_INSERTED_AFTER, LAYOUT_SECTION_COLUMN_INSERTED_BEFORE, LAYOUT_SECTION_ROW_INSERTED_AFTER, LAYOUT_SECTION_ROW_INSERTED_BEFORE, LAYOUT_SECTION_ROW_APPENDED, LAYOUT_SECTION_COLUMNS_RESIZED, LAYOUT_SECTION_ROW_PREPENDED, LAYOUT_SECTION_ROW_CLONED_BELOW, LAYOUT_SECTION_CELL_CLONED_TO_RIGHT].includes(originalActionToPassThrough.type)) {
            const {
              layoutSectionId
            } = originalActionToPassThrough.payload;
            draft.nodePositionsBeforeTreeChange[layoutSectionId] = draft.nodePositions[layoutSectionId];
            return draft;
          }
          return draft;
        }
      case SET_IS_INLINE_FIELD_FOCUSED:
        {
          draft.isInlineEditableFieldFocused = payload;
          return draft;
        }
      default:
        return draft;
    }
  });
};
export default layoutSectionDndReducer;